/**
 * alertDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function alertDirective() {
    return {
        restrict: 'E',
        transclude: {
            actionSlot: '?action',
        },
        template: `
            <md-icon ng-if="icon">{{ icon }}</md-icon>
            <md-icon ng-if="!icon && iconSvg" md-svg-icon="{{ iconSvg }}"></md-icon>
            
            <div class="alert-content" ng-transclude></div>
            
            <div ng-transclude="actionSlot" class="alert__action-slot"></div>
        `,
        scope: {
            icon: '@?icon',
            iconSvg: '@?iconSvg',
        },
    };
}
